import { BalanceType } from '@/entities/balances'
import { BaseEntity } from '@/entities/baseEntity'
import { CryptoCurrencies, Currencies } from '@/entities/curency'

export enum CryptoWithdrawStatus {
  Created = 1,
  InProgress = 2,
  Completed = 3,
  Failed = 4,
}

export type NewCryptoWithdrawModel = {
  requestId: string
  balanceType: BalanceType
  blockchain: CryptoCurrencies
  currency: Currencies
  amount: string
  wallet: string
  comment: string
  isBalanceCommission: boolean
  callbackUrl: string
}

export interface CryptoWithdrawModel extends BaseEntity {
  userId: string
  balanceId: string
  requestId: string
  status: CryptoWithdrawStatus
  blockchain: CryptoCurrencies
  currency: Currencies
  amount: number
  sentAmount: number
  commissionAmount: number
  exchangeRate: number
  wallet: string
  comment: string | null
  isBalanceCommission: boolean
  transactionHash: string | null
  callbackUrl: string | null
  sentAt: string | null
  blockedReason: string | null
}
